module.exports = __webpack_public_path__ + "img/save_as.dcb72e20.svg";